module.exports = __webpack_public_path__ + "static/media/RJ.f4ae210c.jpg";